import { render, staticRenderFns } from "./Wappen.vue?vue&type=template&id=7e0b7210&scoped=true"
import script from "./Wappen.vue?vue&type=script&lang=js"
export * from "./Wappen.vue?vue&type=script&lang=js"
import style0 from "./Wappen.vue?vue&type=style&index=0&id=7e0b7210&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0b7210",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e0b7210')) {
      api.createRecord('7e0b7210', component.options)
    } else {
      api.reload('7e0b7210', component.options)
    }
    module.hot.accept("./Wappen.vue?vue&type=template&id=7e0b7210&scoped=true", function () {
      api.rerender('7e0b7210', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/Wappen.vue"
export default component.exports